// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"241":"644706d04d93f394171e","488":"9613836ea58c65033fa9","532":"59f8ba85c8915f291141","592":"85633cff0cb4ea807213","736":"6098ef9c2f9badebd003"}[chunkId] + ".js";
};